module.exports = __webpack_public_path__ + "static/media/dl.415a9d6a.mp3";